const closedCardsGroupsReducer = (data = [], action) => {
    switch(action.type){
        case 'CLOSED_CARDSGROUPS':
            data = action.data
            return  [...data];
        default:
            return data;
    }
}

export default closedCardsGroupsReducer;